<template>
    <div
        class="flex py-8 items-center justify-center text-center"
        :class="[config.bgImage ? 'bg-cover bg-center' : '', config.ui]"
        :style="
            config.bgImage
                ? {
                      // TODO: make this size responsive + abstract into helper
                      'background-image': `url(${useCloudflareImgUrl(config.bgImage?.imageId, 'landscape', 'md')})`,
                  }
                : undefined
        "
    >
        <OptionalContainer :with-container="!config.skipContainer">
            <h2 class="font-serif text-5xl font-bold">{{ config.title }}</h2>
        </OptionalContainer>
    </div>
</template>

<script setup lang="ts">
import OptionalContainer from './OptionalContainer.vue'
import type { HeroBlockConfig } from '~~/layers/base/types/blockConfigs'

defineProps<{
    config: HeroBlockConfig
}>()
</script>
